const template = require('./paymentDetails.html');

const NS = 'PaymentDetails';

export default function PaymentDetails() {
  "ngInject";

  return {
    bindToController: true,
    controller,
    template,
    controllerAs: 'vm',
    restrict: 'E',
    scope: {
      paymentForm: '=?',
      displayErrors: '=',
      mode: '@', // 'schedule' || 'event' || 'booking'
      isEditBooking: '@?',
      detailsParent: '=',
      disableType: '=',
      privateFunction: "=",
      isChangeByUser: '=?',
      isPaymentTypeChanged: '=?',
      isPriceChanged: '=',
      disabled: '='
    }
  };

  function controller($scope, $mdDialog, appConstants, unregister, $filter) {
    "ngInject";

    const vm = this;
    vm.$onInit = () => vm.initialized = true;

    // if (vm.detailsParent && typeof vm.detailsParent.hasMenuOptionsError === 'undefined') {
    //   vm.hasMenuOptionsError = false;
    // }

    vm.additionalDetailsTypes = [{
      code: appConstants.Payment.PaymentTypes.MenuOptions,
      name: $filter('paymentTypeLabelFilter')(appConstants.Payment.PaymentTypes.MenuOptions),
    }];

    vm.openStates = [];
    vm.overlapRanges = [];

    vm.addAdditionalDetails = addAdditionalDetails;
    vm.removeAdditionalDetails = removeAdditionalDetails;
    vm.convertDate = (date) => date ? new Date(date) : null;

    var listeners = [];
    listeners.push($scope.$watch('vm.detailsParent', guardDetails));
    // listeners.push($scope.$watch(() => vm.detailsParent, (val) => {
    //   console.log('hasMenuOptionsError changed', val);
    // }, true));
    listeners.push($scope.$watch('vm.privateFunction', privateFunctionChange));
    listeners.push($scope.$on('dates-changed', datesChanged));
    listeners.push($scope.$on('$destroy', () => unregister(listeners)));

    function privateFunctionChange() {
      // Guard undefined details
      guardDetails();
      vm.types = updatePaymentTypes();
    }

    function updatePaymentTypes() {
      var paymentTypes = [];

      if (vm.privateFunction) {
        paymentTypes.push(appConstants.Payment.PaymentTypes.NoPayment);
        paymentTypes.push(appConstants.Payment.PaymentTypes.FunctionPayment);
      } else {
        paymentTypes.push(appConstants.Payment.PaymentTypes.NoPayment);
        paymentTypes.push(appConstants.Payment.PaymentTypes.Deposit);
        paymentTypes.push(appConstants.Payment.PaymentTypes.FullPayment);
        if (window.config.preAuth) {
          paymentTypes.push(appConstants.Payment.PaymentTypes.PreAuth);
        }
        if (vm.mode !== 'booking') {
          paymentTypes.push(appConstants.Payment.PaymentTypes.MenuOptions);
        }
      }

      return paymentTypes.map(type => ({
        code: type,
        name: $filter('paymentTypeLabelFilter')(type),
      }));
    }

    function addAdditionalDetails() {
      vm.detailsParent.additionalPaymentDetails.push({});
      vm.openStates.push(false);
      vm.overlapRanges.push(false);
    }

    function removeAdditionalDetails(evt, index) {
      var confirm = $mdDialog.confirm()
        .parent(angular.element(document.body))
        .title('Delete Booking Option')
        .content('Are you sure you would like to delete it?')
        .ariaLabel('Delete Booking Option')
        .ok('Yes')
        .cancel('No')
        .targetEvent(evt);
      $mdDialog.show(confirm).then(() => {
        vm.detailsParent.additionalPaymentDetails.splice(index, 1);
        vm.overlapRanges.splice(index, 1);
        vm.openStates.splice(index, 1);
        datesChanged();
      });
    }

    function guardDetails() {
      // Guard undefined details
      if (vm.detailsParent) {
        vm.detailsParent.paymentDetails = vm.detailsParent.paymentDetails || {
          paymentType: appConstants.Payment.PaymentTypes.NoPayment
        };
        vm.detailsParent.additionalPaymentDetails = vm.detailsParent.additionalPaymentDetails || [];
        vm.openStates = vm.detailsParent.additionalPaymentDetails.map(() => false);
        vm.overlapRanges = vm.detailsParent.additionalPaymentDetails.map(() => false);
      }
    }

    function datesChanged() {

      if (vm.detailsParent && vm.detailsParent.additionalPaymentDetails) {
        const additionals = vm.detailsParent.additionalPaymentDetails;
        var a, b;

        for (let i = 0; i < additionals.length; i++) {
          a = additionals[i];
          vm.overlapRanges[i] = false;
          for (let j = 0; j < additionals.length; j++) {
            if (i !== j) {
              b = additionals[j];
              if ((a.optionsFrom == null || b.optionsTo == null || a.optionsFrom <= b.optionsTo) &&
                (a.optionsTo == null || b.optionsFrom == null || a.optionsTo >= b.optionsFrom)) {
                vm.overlapRanges[i] = true;
                break;
              }
            }
          }
        }
      }

      if (vm.paymentForm.overlaps) {
        if (vm.initialized) {
          vm.paymentForm.overlaps.$setTouched();
        }
        if (vm.overlapRanges.find(v => v) != null) {
          // Invalid
          vm.paymentForm.overlaps.$setValidity('overlaps', false);
        } else {
          // Valid
          vm.paymentForm.overlaps.$setValidity('overlaps', true);
        }
      }
    }
  }
}
